module.exports = __webpack_public_path__ + "static/2-ecf0b8a6c8f01cc0c4bafa8dae816089.jpeg";